import { render, staticRenderFns } from "./Lian.vue?vue&type=template&id=b3c809b6&scoped=true&"
import script from "./Lian.vue?vue&type=script&lang=js&"
export * from "./Lian.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3c809b6",
  null
  
)

export default component.exports